import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'

const LeaderShip = () => {
  return (
    <div className='volto-section our-leadership-section ' id="leadership">
        <Container>

            <Row className='tab-row'>
                <Col xl={9}>
                <SectionHeader mainText1={"The"} mainText2={"Leadership"} />
                <SectionSubHeader headerText={"Our leadership drives innovation, collaboration, and growth."} />
                </Col>
            </Row>
            <Row className='mt-50 leader-row'>

            <Col lg={3} className='varibale-col'>
                <div className='leader-card'>
                    <div className=''>
                    <img className='img-fluid'   src="/images/Venkat-nalliapan-profil.jpeg" alt="Venkat-nalliapan-profile" />
                    <h5>Venkat Nalliapan</h5>
                     <h6>Chief Executive Officer</h6>
                     {/* <p>Volto Consulting and Services LLC</p> */}
                    </div>
                  

                </div>
                 
                 </Col>

                <Col lg={9} className='varibale-col-80'>
                  <div className='about-volto-description ps-lg-3 p-0 volto-leadership'>
                    <p className='mt-0'>Welcome to Volto.</p>
                    <p className='mt-3'>At Volto, we are committed to innovation, excellence, and creating value for our customers, employees, and stakeholders. Since our inception, our mission has been to deliver high-quality solutions that drive success and growth.</p>
                    <p className='mt-3'>In today's fast-evolving world, we believe that staying ahead requires adaptability, creativity, and a relentless focus on customer satisfaction. Our team is dedicated to pushing boundaries, embracing new opportunities, and ensuring that we provide the best possible products and services.</p>
                    <p className='mt-3'>As we move forward, we remain guided by our core values- Customer Centricity, Continuous Growth, and Innovative Approach.. We are excited about the future and look forward to continuing our journey with you.</p>
                    <p className='mt-3'>Thank you for your trust and support. Together, we can achieve great things.</p>
                  </div>
                 
                </Col>


            </Row>



        </Container>

    </div>
  )
}

export default LeaderShip;


{/* <Col lg={3} md={6} >
<div className='leadership-card '>
   <div className='layer ceo'><img src="/images/ceo.svg" alt="ceo" /></div>
   <h5>Venakateswara Raja</h5>
   <p>Founder & CEO</p>
</div>
</Col>
<Col lg={3} md={6}>
<div className='leadership-card '>
   <div className='layer cto'><img src="/images/cto.svg" alt="cto" /></div>
   <h5>John Doe</h5>
   <p>Chief Technology Officer</p>
</div>
</Col>
<Col lg={3} md={6}>
<div className='leadership-card '>
   <div className='layer cmo'><img src="/images/cmo.svg" alt="cmo" /></div>
   <h5>Jane Smith</h5>
   <p>Chief Marketing Officer</p>
</div>
</Col>
<Col lg={3} md={6}>
<div className='leadership-card '>
   <div className='layer operation-head'><img src="/images/operation-head.svg" alt="operation-head" /></div>
   <h5>Alex Johnson</h5>
   <p>Chief Operations Officer</p>
</div>
</Col> */}